import datepicker from 'js-datepicker'

/**
 * Datepickers
 *
 */
const init = function() {
  const inputs = document.querySelectorAll('.js-datepicker');
  if (inputs.length > 0) {
    inputs.forEach(element => {
      datepicker(element, {
        formatter: (input, date, instance) => {
          const value = date.toLocaleDateString()
          input.value = value
        }
      });
    });
  }
}

export default {
  init,
}
